import React from "react";
import { FaExclamationTriangle, FaCheck, FaTimes } from "react-icons/fa";

function CustomConfirmationModal({
  open,
  title,
  message,
  action,
  onClose,
  onConfirm,
  connectDuringOperation,
  setConnectDuringOperation,
}) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[10000]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-2xl p-6 w-full max-w-md mx-4"
        onClick={(e) => e.stopPropagation()} // Prevent modal close on content click
      >
        {/* Header */}
        <div className="flex items-center mb-4">
          <div className="rounded-full bg-yellow-100 p-2 mr-3">
            <FaExclamationTriangle className="text-yellow-500 w-6 h-6" />
          </div>
          <span className="text-xl font-semibold text-gray-800">{title}</span>
        </div>

        {/* Message */}
        <p className="text-gray-600 text-base mb-4">{message}</p>

        {/* Connection Preference */}
        <div className="bg-gray-50 p-3 rounded-lg mb-5 border border-gray-200">
          <label className="flex items-start cursor-pointer">
            <input
              type="checkbox"
              checked={connectDuringOperation}
              onChange={(e) => setConnectDuringOperation(e.target.checked)}
              className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-3 text-gray-700 text-base">
              İşlem yapılırken cihaza bağlantı kur
              <div className="text-sm text-gray-500 mt-1">
                Bu seçenek, cihaz işlemi sırasında otomatik olarak bağlantı
                kurulmasını sağlar.
              </div>
            </span>
          </label>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            className="flex items-center text-base gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors"
            onClick={onClose}
          >
            <FaTimes className="text-gray-500 w-4 h-4" />
            İptal
          </button>
          <button
            className="flex items-center text-base gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
            onClick={onConfirm}
          >
            <FaCheck className="text-white w-4 h-4" />
            Onaylıyorum
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomConfirmationModal;
